import SignalRApiService from './SignalRApiService'
import UserApiService from './UserApiService'
import InvoicesApiService from './InvoicesApiService'
import ClientApiService from './ClientApiService'
import CandidateApiService from './CandidateApiService'
import FileApiService from './FileApiService'
import TimesheetsApiService from './TimesheetsApiService'
import ContactsApiService from './ContactsApiService'
import LocationsApiService from './LocationsApiService'
import BookingsApiService from './BookingsApiService'
import PendingFeedbackApiServiceApiService from './PendingFeedbackApiServiceApiService'
import ClientGroupApiService from './ClientGroupApiService'
import PendingBookingsApiService from './PendingBookingsApiService'
import SearchBookingsApiService from './SearchBookingsApiService'
import FeaturesApiService from './FeaturesApiService'

export default {
  pendingfeedbacks: new PendingFeedbackApiServiceApiService(),
  bookings: new BookingsApiService(),
  locations: new LocationsApiService(),
  contacts: new ContactsApiService(),
  timesheets: new TimesheetsApiService(),
  file: new FileApiService(),
  invoices: new InvoicesApiService(),
  client: new ClientApiService(),
  clientGroups: new ClientGroupApiService(),
  candidate: new CandidateApiService(),
  user: new UserApiService(),
  signalR: new SignalRApiService(),
  pendingBookings: new PendingBookingsApiService(),
  searchBookings: new SearchBookingsApiService(),
  features: new FeaturesApiService(),
}
